export const Blocked_Input_List = [
  "waitfor",
  "waitfor delay",
  "grant ",
  "--",
  ";",
  "/*",
  "*/",
  "@@",
  "alter ",
  "begin ",
  "create ",
  "cursor ",
  "kill ",
  "declare ",
  "delete ",
  "drop ",
  " end",
  "exec ",
  "execute ",
  "fetch ",
  "insert ",
  "open ",
  "select ",
  "sysobjects",
  "syscolumns",
  "table ",
  "update ",
  "="
];
